export const getEmailTemplate = (data) => `<strong>First Name: </strong> ${data.firstname} <br/>
    <strong>Last Name: </strong> ${data.lastname} <br/>
    <strong>Email: </strong> ${data.email} <br/>
    <strong>Phone: </strong> ${data.phone} <br/>
    <strong>Message Topic: </strong> ${data.messagetopic} <br/>
    <strong>Message: </strong> ${data.message} <br/>`;